import { Dropdown } from '../../../LEGACY/elemental'
import { ProfilePicture } from '../../generic'
import { history } from '../../../store'
import { Home, User, UserRole } from '@lmc/ts-common'
import { FC } from 'react'
import { getProfileMenuItems } from '../utils'

type Props = {
  handleSignout: () => void
  handleHomeSwitch: () => void
  handleSwitchOfficer: () => void
  handleManageAccount: () => void
  user: User
  home: Home
  onHover?: boolean
}

export const ProfileItem: FC<Props> = ({
  handleSignout,
  handleHomeSwitch,
  handleSwitchOfficer,
  handleManageAccount,
  user,
  home,
  onHover,
}) => {
  const handleSelect = (path: string) => {
    if (path === 'signout') {
      handleSignout()
    } else if (path === 'switch') {
      handleHomeSwitch()
    } else if (path === 'admin-view') {
      handleSwitchOfficer()
    } else if (path === 'privacy-officer-view') {
      handleSwitchOfficer()
    } else if (path === 'manage-account') {
      handleManageAccount()
    } else {
      history.push(`/${path}`)
    }
  }

  const isPrivacyOfficer = () => {
    return home.privacyOfficers
      ?.map((officer) => officer?.user)
      ?.includes(user?.id)
  }

  const privacyOfficerEnabled =
    user.role === UserRole.careHomeAdmin && isPrivacyOfficer()

  return (
    <Dropdown
      items={getProfileMenuItems(user, privacyOfficerEnabled)}
      onSelect={(item: string) => handleSelect(item)}
      alignRight
      onHover={onHover}
      data-cy="profile-dropdown"
    >
      <div style={styles.container}>
        <ProfilePicture
          style={styles.profilePic}
          type="small"
          url={user && user.picture}
          alt=""
        />
      </div>
    </Dropdown>
  )
}

const styles = {
  container: {
    cursor: 'pointer',
  },
  menu: {
    position: 'relative',
    top: 30,
    color: 'black',
  },
  profilePic: {
    backgroundSize: 30,
    height: 33,
    width: 33,
  },
}
